<ng-template #descTemplate>
  <span class="text-muted">
      <span class="item-list-job-title">
        <span [innerHTML]="mdRepresentation.firstMetadataValue(['dc.description'], undefined, true)"></span>
      </span>
  </span>
</ng-template>
<ds-truncatable [id]="mdRepresentation.id">
  <a [routerLink]="[itemPageRoute]"
     [innerHTML]="mdRepresentation.getValue()"
     [ngbTooltip]="mdRepresentation.hasMetadata(['dc.description']) ? descTemplate : null"></a>
</ds-truncatable>
